export class CustomTranslationState {
  /**
   * @var {CustomTranslationForm}
   */
  customTranslationForm;
}
